export default __webpack_public_path__ + "static/media/martijn.d0d7da64.png";